import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-pow-time-approvals',
  templateUrl: './pow-time-approvals.component.html',
  styleUrls: ['./pow-time-approvals.component.css']
})
export class PowTimeApprovalsComponent implements OnInit {
    public itemsListApprovals: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadApprovals(): Promise<void> {
        this.itemsListApprovals = await this.datatask.Post(1246);
    }

    private async init() {
        this.loadApprovals();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('powTimeApprovals', {
//        templateUrl: 'views/components/views/powTimeApprovals/powTimeApprovals.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['powTimeApprovalsService', function (powTimeApprovalsService) {
//            const vm = this;

//            vm.model = {
//                itemsListApprovals: []
//            };

//            async function loadApprovals() {
//                vm.model.itemsListApprovals = (await powTimeApprovalsService.listApprovals());
//            }

//            vm.$onInit = function () {
//                loadApprovals();
//            };
//        }]
//    });
//})();
